import _ from 'lodash';
import { AGENT_SOFTWARE_VERSION_FIELD } from './AgentConstants';

export function softwareVersionMapper(row, column) {
    const { mapping } = column;

    const fullVersion = _.get(row, mapping);

    if (!fullVersion) {
        return '';
    }

    return parseAgentSoftwareVersion(fullVersion);
}

export function parseAgentSoftwareVersion(versionString) {
    const versionSeparator = '_';
    const dashSeparator = '-';
    const newVersionStart = 0;

    if (!versionString) {
        return '';
    }

    // Old Version format: 3.3506-44dd6e9_3.3.3506, we want to display: 3.3506
    // New Version format: 3.7.0-0.66.0-7b3e5e8_3.3.7.0-0.66.0, we want to display: 3.7.0-0.66.0

    const fullVersionParts = versionString.split(versionSeparator);
    let softwareVersionParts = _.first(fullVersionParts).split(dashSeparator);
    // If we have more than one part we are working with the new version style 3.7.0-0.66.0-7b3e5e8_3.3.7.0-0.66.0
    // We now have [3.7.0, 0.66.0, 7b3e5e8], get rid of the hash
    if (softwareVersionParts.length > 1) {
        softwareVersionParts = _.slice(softwareVersionParts, newVersionStart, softwareVersionParts.length - 1);
    }

    // and join them back up with a -
    return softwareVersionParts.join(dashSeparator);
}

export function isSoftwareOutOfDate(agentVersion, compareToVersion) {
    if (!agentVersion || !compareToVersion) {
        return false;
    }

    // Platform.Major.Minor.Patch-Hotfix.Build.Iteration
    // 3.3.7.0-0.66.0
    const agent = softwareVersionToNumberArray(agentVersion);
    const compare = softwareVersionToNumberArray(compareToVersion);

    // They are on the old version 3.3358
    if (agent.length < compare.length) {
        return true;
    }

    // They are on a newer version than we have available
    if (agent.length > compare.length) {
        return false;
    }

    for (let i = 0; i < compare.length; ++i) {
        if (agent[i] > compare[i]) {
            // If any component of the agent version is greater than the compare version, it can't be
            // out of date.
            return false;
        }

        if (agent[i] < compare[i]) {
            // If any component of the agent version is less than the compare version, it is out
            // of date.
            return true;
        }
    }

    // If we got here, the versions are identical.
    return false;
}

export function getAgentVersion(versionInfo) {
    const softwareVersion = versionInfo.version ? _.get(versionInfo, AGENT_SOFTWARE_VERSION_FIELD, '') : versionInfo;

    if (!softwareVersion) {
        return '';
    }

    return parseAgentSoftwareVersion(softwareVersion);
}

export function formatLatestAgentVersion(versionString) {
    const versionSeparator = '.';
    const versionStart = 1;

    if (!versionString) {
        return '';
    }

    const versionParts = versionString.split(versionSeparator);
    return _.slice(versionParts, versionStart, versionParts.length).join(versionSeparator);
}

function softwareVersionToNumberArray(versionString) {
    const dashSeparator = '-';
    const dotSeparator = '.';
    const oldVersionStyle = 1;
    if (!versionString) {
        return [];
    }

    // Platform.Major.Minor.Patch-Hotfix.Build.Iteration
    // 3.3.7.0-0.66.0

    const versionParts = versionString.split(dashSeparator);
    if (versionParts.length === oldVersionStyle) {
        return stringArrayToInt(_.first(versionParts).split(dotSeparator));
    }

    // New style version
    return stringArrayToInt([
        ..._.first(versionParts).split(dotSeparator),
        ..._.last(versionParts).split(dotSeparator),
    ]);
}

function stringArrayToInt(stringArray) {
    return _.map(stringArray, (part) => parseInt(part, 10));
}
